import IntervalParser from './main';

export default {
  main: IntervalParser,
};
